<template>
    <div>
        <div v-if="loading && flavorConfig.payConfig.yookassa" class="text-center">
            {{ $t('payment_loading') }}...
            <base-progress
                    :animated="true"
                    :show-percentage="false"
                    :value="50"
                    class="pt-0"/>
        </div>

        <div v-if="errorMsg">
            <base-alert type="danger">{{errorMsg}}</base-alert>
        </div>
        <div id="yookassa"></div>

        <base-button v-show="flavorConfig.payConfig.revolut"
                        icon="fa fa-credit-card fa-2x"
                        class="my-2 py-2 w-100 payment-paypal-btn"
                        @click="loadRevolut"
                        title="Revolut">
            Revolut ( {{item.price}} € )
        </base-button>

        <div v-show="item && (item.paypalClientId && flavorConfig.payConfig.paypal)" class="text-left pa-1">
            <div class="mb-2">{{ $t('other_payment_methods') }}:</div>
            <base-button v-show="paySystem!='paypal'"
                         icon="fab fa-paypal fa-2x"
                         class="my-2 w-100 payment-paypal-btn"
                         @click="loadPaypal"
                         title="paypal">
                Paypal
            </base-button>
            <div v-show="paySystem=='paypal'" id="paypaldiv" class="mt-2"></div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios'
    import RevolutCheckout from "@revolut/checkout"

    export default {
        name: 'PayWidget',
        props: {
            item: {type: [Object], default: null}
        },

        data: () => ({
            yooScriptLoaded: false,
            loading: false,
            errorMsg: '',
            paySystem: 'yookassa',
            revolutItem: undefined,
        }),

        computed: {},

        watch: {
            item: function (item, oldItem) {
                console.log('kassa watch')
                if (this.yooScriptLoaded && this.item && this.item.price) this.createYooOrder(this.item)
                else if (this.item && this.item.hasOwnProperty('price') && !this.item.price) {
                    this.errorMsg = 'Цена пакета не установлена. Оформление заказа не возможно, обратитесь, пожалуйста, в поддержку.'
                }
            },
        },

        async mounted() {
            if (this.flavorConfig.payConfig.yookassa) {
                this.loadYookassa()
            }
        },

        methods: {
            loadYookassa() {
                Vue.loadScript('https://yookassa.ru/checkout-widget/v1/checkout-widget.js')
                    .then(() => {
                        console.log('YandexKassa loaded')
                        this.yooScriptLoaded = true
                        if (this.item && this.item.price) this.createYooOrder(this.item)
                        else if (this.item && this.item.hasOwnProperty('price') && !this.item.price) {
                            this.errorMsg = this.$t('payment_addpack_error')
                        }
                    })
                    .catch(() => {
                        console.log('Can not load yookassa library')
                    });
            },

            showKassa(token, user_payment_id) {
                this.removeKassa()

                this.checkout = new window.YooMoneyCheckoutWidget({
                    confirmation_token: token, // Токен, который перед проведением оплаты нужно получить от Яндекс.Кассы
                    return_url: process.env.VUE_APP_URL + '/home-teacher/paymentstatus/' + user_payment_id, // Ссылка на страницу завершения оплаты
                    error_callback(error) {
                        // Обработка ошибок инициализации
                        console.log(error)
                    },
                })
                this.checkout.render('yookassa')
            },

            removeKassa() {
                if (this.checkout) {
                    document.getElementById('yookassa').innerHTML = ''
                    delete this.checkout
                }
            },

            loadPaypal() {
                if (!this.item.paypalClientId || !this.item.price) return

                this.paySystem = 'paypal'
                const me = this

                Vue.loadScript(`https://www.paypal.com/sdk/js?client-id=${me.item.paypalClientId}&currency=EUR`)
                    .then(() => {
                        paypal.Buttons({
                            createOrder: function (data, actions) {
                                return actions.order.create({
                                    purchase_units: [{
                                        //reference_id: 'reference_id2',
                                        custom_id: me.item.user_payment_id,
                                        invoice_id: me.item.user_payment_id,
                                        amount: {
                                            value: me.item.price
                                        }
                                    }],
                                });
                            },
                            onApprove: function (data, actions) {
                                return actions.order.capture().then(function (details) {
                                    //alert('Transaction completed by ' + details.payer.name.given_name);
                                    me.$emit('captured', {pay_agent: 'paypal', details: details})
                                });
                            }
                        }).render('#paypaldiv')
                        this.paySystem = 'paypal'
                    })
                    .catch(() => {
                        console.log('Can not load paypal library')
                    })
            },


            async loadRevolut () {
                if (this.loading || !this.item.price) return
                this.loading = true

                const response = await axios({method: 'post', url: '/payment/revolut_order', data: this.item})
                const mode = response.data.sandbox ? "sandbox" : "prod" // process.env.NODE_ENV === 'production' ? "prod" : "sandbox"
                this.revolutItem = response.data
                this.revolutItem.fl_recurrent = this.item.recurrent
                // console.log(response, response.data.public_id, mode)

                RevolutCheckout(this.revolutItem.public_id, mode).then((RC) => {
                    this.revolutPopup(RC)
                    this.paySystem = 'revolut'
                    this.loading = false
                })
            },

            revolutPopup (RC) {
                const me = this
                RC.payWithPopup({
                    // name: "First Last",
                    email: me.revolutItem.email,
                    phone: me.revolutItem.phone,
                    savePaymentMethodFor: me.item.recurrent ? 'merchant' : undefined,
                    onSuccess() {
                        me.checkRevolutStatus()
                    },
                    onError(message) {
                        window.alert(message);
                    },
                    onCancel() {
                        // window.alert("Payment cancelled!");
                    },
                })
            },

            async checkRevolutStatus () {
                this.loading = true
                /* После получения от виджета сообщения об удачной оплате сразу проверяем состояние заказа через вызов коллбэка.
                   Там же сразу проводятся все операции по подтверждению оплаты,  привязки курсов и т.п.
                   В принципе можно этого не делать, а просто переходить на страницу статуса заказа,
                   если настроен коллбэк (он подключается в автоплатежах)
                   А так будет двойное подтверждение - здесь и через коллбэк, но есть проверка на повторное подтверждение.
                */
                const response = await axios({method: 'post', url: '/paycallback/revolut', data: this.revolutItem})
                if(response.data.success) {
                    this.$emit('captured', {pay_agent: 'revolut', details: this.revolutItem})
                }
                this.loading = false
            },

            async createYooOrder(item) {
                if (this.loading || !this.yooScriptLoaded) return
                this.loading = true
                this.removeKassa()
                try {
                    item.metadata = {
                        user_payment_id: item.user_payment_id,
                        addpack: item.addpack,
                        timetable_id: item.timetable_id,
                        client_id: item.client_id,
                        phone: item.phone,
                        comment: item.comment,
                        cert_name: item.cert_name,
                        cert_text: item.cert_text,
                    }

                    const response = await axios({method: 'post', url: '/payment/yoo', data: item})
                    console.log(response)
                    //this.$emit('paymentdata', response.data)

                    if (response.data.amount.value > 0) {
                        this.showKassa(response.data.confirmation.confirmation_token, item.user_payment_id)
                    }
                    setInterval(() => {
                        this.loading = false
                    }, 2000)
                } catch (error) {
                    console.log(error)
                    let data = (error && error.response) ? error.response.data : {}
                    this.errorMsg = this.pretty(data)
                    this.loading = false
                }
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },

        },
    }
</script>
